import { render, staticRenderFns } from "./ms.vue?vue&type=template&id=1309ae7a"
import script from "./ms.vue?vue&type=script&lang=js"
export * from "./ms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports